import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownProviderComponent } from './components/dropdown-provider/dropdown-provider.component';
import { FormsModule } from '@angular/forms';

@NgModule({
    imports: [
        CommonModule,
        FormsModule
    ],
  declarations: [DropdownProviderComponent],
  exports: [
    DropdownProviderComponent
  ]
})
export class DropdownProviderModule { }



// WEBPACK FOOTER //
// ./src/app/utils/dropdown-provider/dropdown-provider.module.ts